/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Center, Image, Link, Text } from '@chakra-ui/react'

import { useLocation, useNavigate } from 'react-router-dom'
import { isSuccessStatus } from 'utils/functions/validations'
import { emailObfuscator } from 'utils/functions/emailOfuscado'
import error from '../assets/images/error.svg'
import noAccess from '../assets/images/no-access.svg'
import urgentPriority from '../assets/images/urgent-priority.svg'
import enlaceRoto from '../assets/images/enlace-roto.svg'
import { useSubscriberContext } from '../providers/SubscriberProvider'
import { InformativeLayer } from 'components/informativeLayer'

const RecoveryErrorPage = () => {
  const { subscriberData, resendValidationEmail } = useSubscriberContext()
  const { email, documento, pais, nacionalidad} = subscriberData
  const navigate = useNavigate()
  const { state }: any = useLocation() || {}
  const { pageBefore, messageType = 'BLANQUEO_CREDENCIALES' } = state || {}
  const isRecoveryUser = pageBefore === 'recoveryUser500'
  const isRecoveryTokenInvalid = pageBefore === 'recoveryTokenInvalid'
  //
  const isRecoveryUserErrorTimes = pageBefore === 'recoveryUser409' && messageType === 'COD_ERROR_TIMES_RECOVERY'
  const isRecoveryUserErrorAttempts = pageBefore === 'recoveryUser409' && messageType === 'COD_ERROR_ATTEMPTS'
  const isRecoveryUserErrorOperator = pageBefore === 'recoveryUser409' && messageType === 'COD_ERROR_OPERATOR'
  const isRecoveryUserErrorSentRecently = pageBefore === 'recoveryUser409' && messageType === 'COD_ERROR_EMAIL_SENT_RECENTLY'
  const isRecoveryUserErrorSentExceeded = pageBefore === 'recoveryUser409' && messageType === 'COD_ERROR_EMAIL_SENT_EXCEEDED_TIMES'
      

  const redirectSib = 'https://sib1.interbanking.com.ar/secureLogin.do?from=home'
  
  const messages = {
    RECOVERY_USER_ERROR_TIMES: 'Ya recuperaste tus credenciales hoy',
    RECOVERY_USER_ERROR_SENT_RECENTLY: 'Ya tenés un email de recuperación vigente',
    RECOVERY_USER_ERROR_ATTEMPTS: 'Superaste el máximo de intentos',
    RECOVERY_USER_ERROR_EXCEEDED: 'Superaste el máximo de intentos',
    RECOVERY_USER_ERROR_OPERATOR: 'Ya sos operador de Interbanking',
    RECOVERY_USER: 'No podemos acceder a tu información',
    RECOVERY_INVALID_TOKEN: 'Enlace inválido o vencido',
    RECOVERY_USER_ERROR: 'La información no está disponible ',
    DEFAULT: 'No hemos tenido suerte con el link de validación.',
  }

  const subtitleMessages = {
    RECOVERY_USER_ERROR_TIMES: (
      <>
        Solo podés recuperar tu usuario y contraseña una vez cada 24 horas.<br />
        Intentá en otro momento.
      </>
    ),
    RECOVERY_USER_ERROR_ATTEMPTS: (
      <>
        Ingresaste un dato erróneo en varias oportunidades.<br />
        Volvé a intentar en 24 horas.
      </>
    ),
    RECOVERY_USER_ERROR_EXCEEDED: (
      <>
        No podemos enviar más emails de recuperación en el día.<br />
        Volvé a intentar en 24 horas.
      </>
    ),
    RECOVERY_USER_ERROR_SENT_RECENTLY: (
      <>
        El link que te enviamos es válido por (5) minutos.<br />
        Recordá revisar la carpeta de spam.
      </>
    ),
    RECOVERY_USER_ERROR_OPERATOR: (
      <>
        Podés recuperar tus credenciales en la sección <b>Gestión de claves</b> de la plataforma.
      </>
    ),
    RECOVERY_USER: 'Estamos trabajando para solucionarlo, volvé a intentar más tarde.',
    RECOVERY_INVALID_TOKEN: (
      <>
        Este link es valido por (5) minutos.<br />
        Pasado ese tiempo, deberás solicitar uno nuevo.
      </>
    ),
    RECOVERY_USER_ERROR: 'Estamos trabajando para solucionarlo, volvé a intentar más tarde.',
    DEFAULT: 'El link ingresado no es válido o caducó, te sugerimos crear tu cuenta nuevamente en 24 horas',
  }

  const textButtonMessages = {
    GESTION_CLAVE: 'Gestionar clave',
    RECOVERY_INVALID_TOKEN: 'Volver al inicio',
    RECOVERY_USER_ERROR: 'Volver al inicio',
    INVALID_TOKEN: '',
  }

  const title = () => {
    if (isRecoveryUserErrorTimes) return messages.RECOVERY_USER_ERROR_TIMES
    if (isRecoveryUserErrorAttempts) return messages.RECOVERY_USER_ERROR_ATTEMPTS
    if (isRecoveryUserErrorSentExceeded) return messages.RECOVERY_USER_ERROR_EXCEEDED
    if (isRecoveryUserErrorOperator) return messages.RECOVERY_USER_ERROR_OPERATOR
    if (isRecoveryUserErrorSentRecently) return messages.RECOVERY_USER_ERROR_SENT_RECENTLY
    if (isRecoveryUser) return messages.RECOVERY_USER
    if (isRecoveryTokenInvalid) return messages.RECOVERY_INVALID_TOKEN
    return messages.DEFAULT
  }

  const subtitle = () => {
    if (isRecoveryUserErrorTimes) return subtitleMessages.RECOVERY_USER_ERROR_TIMES
    if (isRecoveryUserErrorAttempts) return subtitleMessages.RECOVERY_USER_ERROR_ATTEMPTS
    if (isRecoveryUserErrorSentExceeded) return messages.RECOVERY_USER_ERROR_EXCEEDED
    if (isRecoveryUserErrorOperator) return subtitleMessages.RECOVERY_USER_ERROR_OPERATOR
    if (isRecoveryUserErrorSentRecently) return subtitleMessages.RECOVERY_USER_ERROR_SENT_RECENTLY
    if (isRecoveryUser) return subtitleMessages.RECOVERY_USER
    if (isRecoveryTokenInvalid) return subtitleMessages.RECOVERY_INVALID_TOKEN
    return subtitleMessages.DEFAULT
  }

  const textButton = () => ''
  
  const handleResendEmail = async () => {
    try {
      const response = await resendValidationEmail(email, documento , messageType, pais, nacionalidad)
      if (!isSuccessStatus(response.status)) {
        navigate('/suscripcion/error-correo')
      } else {
        const EmailHidden = emailObfuscator(email)
        navigate('/suscripcion/correo', { state: { pageBefore: 'recovery', userEmail: EmailHidden } })
      }
    } catch (_) {
      navigate('/suscripcion/error-correo')
    }
  }

  const imagen = () => {
    if (isRecoveryUserErrorTimes) return noAccess
    if (isRecoveryUserErrorAttempts) return urgentPriority
    if (isRecoveryUserErrorSentExceeded) return urgentPriority
    if (isRecoveryUserErrorOperator) return urgentPriority
    if (isRecoveryUserErrorSentRecently) return urgentPriority
    if (isRecoveryTokenInvalid) return enlaceRoto
   return error
  }

  const subtitleMaxWidth = () => (isRecoveryUserErrorTimes || isRecoveryUserErrorOperator || isRecoveryUserErrorAttempts || isRecoveryUserErrorSentRecently || isRecoveryUserErrorSentExceeded)
  
  const imagenWidth = () => {
    if (isRecoveryTokenInvalid) return '75.94px'
    if (isRecoveryUserErrorOperator || isRecoveryUserErrorTimes || isRecoveryUserErrorSentRecently || isRecoveryUserErrorSentExceeded) return '80px'
    return ''
  }

  const imagenHeight = () => {
    if (isRecoveryTokenInvalid) return '76px'
    if (isRecoveryUserErrorOperator || isRecoveryUserErrorTimes || isRecoveryUserErrorSentRecently || isRecoveryUserErrorSentExceeded) return '80px'
    return ''
    }
  const determineAction = () => {
    if (isRecoveryUserErrorOperator) return undefined
    if (isRecoveryTokenInvalid)  return undefined
    if (email)  return handleResendEmail
    return undefined
  }

  const supportLink = () => {
    if  (isRecoveryUserErrorOperator) {
      return (
      <Center w='100%' mt={4}>
        <Link
          data-testid="recoveryUserErrorOperator-link"
          className='linkDefault'
          textStyle='labelLgBoldUnderline'
          href={redirectSib}
        >
          {textButtonMessages.GESTION_CLAVE}
        </Link>
      </Center>
      )
    } 
    if (isRecoveryTokenInvalid || isRecoveryUserErrorSentRecently || isRecoveryUserErrorSentExceeded) {
      return (
        <Center w='100%' mt={4}>
          <Link
            data-testid="recoveryTokenInvalid-link"
            className='linkDefault'
            textStyle='labelLgBoldUnderline'
            onClick={() => navigate('/suscripcion/recuperar')}
          >
            {textButtonMessages.RECOVERY_INVALID_TOKEN}
          </Link>
        </Center>
        )  
    }
    return ''
  }

  useEffect(() => () => {
    window.history.replaceState({}, null)
  }, [])
  
  return (
    <div>
      <InformativeLayer data-testid="recoveryError-informative"
        action = {determineAction()}
        textButton = {textButton()}
        title={<Text>{title()}</Text>}
        subtitle={<Text>{subtitle()}</Text>}
        Image={<Image src={imagen()} alt='Lateral image' />}
        support={supportLink()}
      />
    </div>
  )
}

export default RecoveryErrorPage
